/* eslint-disable max-len */
function CooperationSvg(props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> {
    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_38017_7270" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_38017_7270)">
            <path d="M6.7499 8.7C8.11681 8.7 9.2249 7.5919 9.2249 6.225C9.2249 4.8581 8.11681 3.75 6.7499 3.75C5.383 3.75 4.2749 4.8581 4.2749 6.225C4.2749 7.5919 5.383 8.7 6.7499 8.7Z" stroke="#39404D" strokeWidth="1.125" />
            <path d="M11.25 8.7C12.6169 8.7 13.725 7.5919 13.725 6.225C13.725 4.8581 12.6169 3.75 11.25 3.75" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M2.25 13.2C2.25 11.7088 3.45883 10.5 4.95 10.5H8.55C10.0412 10.5 11.25 11.7088 11.25 13.2C11.25 13.6971 10.8471 14.1 10.35 14.1H3.15C2.65294 14.1 2.25 13.6971 2.25 13.2Z" stroke="#39404D" strokeWidth="1.125" />
            <path d="M12.1499 10.5H13.0499C14.5411 10.5 15.7499 11.7088 15.7499 13.2C15.7499 13.6971 15.347 14.1 14.8499 14.1H13.0499" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" />
        </g>
    </svg>;
}

export default CooperationSvg;
